<template lang="pug">
  .component-create-vehicle-category
    .row
      .column
        label Name
          input(type="text", v-model="body.name")
        label Description
          textarea(rows="5", v-model="body.description")
      .column
        label Vehicle Types
          select(v-model="body.vehicle_type_id")
            option(v-for="vehicleType in vehicleTypes", :value="vehicleType.id") {{vehicleType.name}}
        label Category image
        KeplerFileUpload(selected-prefix="vehicle-categories", selected-visibility="public", @sel="handleFileSelector", :previewUrl="body.picture")

        label Category damage picture
        KeplerFileUpload(selected-prefix="damage-picture", selected-visibility="public", @sel="handleFileDamageSelector", :previewUrl="body.damage_picture")

    .row.column
      button.button(@click="addVehicleCategory") Create

</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import Dropzone from '../../components/structure/Dropzone'
  import MaggieHelper from '../../maggieHelper'
  import KeplerFileUpload from '../../components/structure/KeplerFileUpload'

  export default {
    name: 'CreateVehicleCategory',
    components: {KeplerFileUpload, Dropzone},
    data() {
      return {
        dropzoneUlr: KeplerBackofficeSdk.getUrlForDropzone(),
        vehicleTypes: null,

        body: {
          name: null,
          vehicle_type_id: null,
          description: null,
          picture: null,
          damage_picture: null

        },
        attachment_token: null
      }
    },
    created() {
      KeplerBackofficeSdk.vehicleTypes.list.all((data) => {
        this.vehicleTypes = data
      })
    },
    methods: {
      addVehicleCategory() {

        KeplerBackofficeSdk.vehicleCategories.make(this.body, (data) => {
          MaggieHelper.notification('Vehicle Category', 'Vehicle Category Created')
          if (!this.attachment_token) {

            this.$router.push({path: 'assets', name: 'categories'})
          } else {
            var body = {attachment_token: this.attachment_token}
            KeplerBackofficeSdk.vehicleCategories.select(data.id).addPicture(body, (data) => {
              this.$router.push({path: 'assets', name: 'categories'})
            })
          }
        })

      },
      handleFileSelector(path) {
        this.body.picture = path
      },
      handleFileDamageSelector(path) {
        this.body.damage_picture = path
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateVehicleCategory.vue?6a730368